import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import { getDeclinationString, getEducationStartEndDate } from './api'
import { ICommonState, ICommonActions, IEduDateStartEnd } from './state.types'


export const initialStateCommon: ICommonState = {
    error: null,
    isLoading: false,
}

/** Хранилище страницы - Авторизация */
export const useCommon = create<ICommonState & ICommonActions>()(devtools((set) => ({
    ...initialStateCommon,


    clearCommonState: () => {set(initialStateCommon)},
    
    /** Получение - Даты начала обучения и конец обучения */
    actionGetEduDateStartEnd: async (startDate?: string, countMonthOrWeek?: number, isWeek?: number) => {
        set({isLoading: true})

        let returnData: IEduDateStartEnd = {
            eduStartDate: '',
            eduEndDate: ''
        }

        const res = await getEducationStartEndDate(startDate, countMonthOrWeek, isWeek)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK' && res.data) {
            set({error: null})
            returnData = res.data
        }

        set({isLoading: false})
        
        return returnData
    },

    /** Получение - Склонение строки */
    actionGetDeclinationString: async (fio?: string, post?: string) => {
        set({isLoading: true})

        const res = await getDeclinationString(fio, post)
        if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        if (res.message === 'OK') {}

        set({isLoading: false})
        
        return res
    },
    
}), {name: 'commonState'}))